/* eslint-disable @typescript-eslint/no-explicit-any */

import { Injectable } from '@angular/core';

import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse, HttpParams, HttpClient
} from '@angular/common/http';

import {finalize, Observable, of} from 'rxjs';
import { catchError, map } from 'rxjs/operators';
// import {NotificationManagerService} from "../services/utils/notification-manager.service";
// import {LoaderService} from "../services/utils/loader.service";
import {CustomHttpInterceptParams, InterceptorCloneRequest} from "../models/http.models";
import {environment} from "../../environments/environment";
import {AuthService} from "../services/auth.service";
import {HttpService} from "../services/http.service";
import {MessageService} from "primeng/api";

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  constructor(private messageService : MessageService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.startsWith(environment.apiUrl)){
      return next.handle(request);
    }

    const params = this.getParams(request.params);

    //Controllo se nei parametri ci sono dei caratteri in blackList
    if(request.method.toUpperCase() == "POST"){
      let parameters = request.body;
      let jsonRequestControl = new InterceptorCloneRequest();

      let data = "";
      if(parameters != null){
        data = JSON.stringify(parameters);
      }

      jsonRequestControl = this.controlParameter(data);

      if (jsonRequestControl.replace) {
        request = request.clone({ body: jsonRequestControl.data });
      }
    }

    // if (params.showLoader)
    //   this.loaderService.show();

    if (AuthService.AuthToken) {
      request = request.clone({
          setHeaders: { Authorization: `Bearer ${AuthService.AuthToken}` }
      });
    }

    return next
      .handle(request)
      .pipe(
        map((e) => {
          return e;
        }),
        catchError((err: any) => {
          if (params.showLoader)
            // this.loaderService.hide();

          if (err instanceof HttpErrorResponse) {
            switch (err.status) {
              case 0:
                console.log('Impossibile stabilire una comunicazione con il server. Contattare l\'amministratore di sistema');
                break;

              default:
                console.log(JSON.stringify(err));

                // if (err.error) {
                //   this.notifiationService.showError(err.error.message);
                // }
                break;
            }
          }

          return of(err);
        }),
        finalize(() => {
          // if (params.showLoader)
          //   this.loaderService.hide();
        }));
  }

  getParams(params?: HttpParams): CustomHttpInterceptParams {
    if (params && params instanceof CustomHttpInterceptParams) {
      return params as CustomHttpInterceptParams;
    }

    return new CustomHttpInterceptParams();
  }

  controlParameter(data: string): InterceptorCloneRequest {
    let model = new InterceptorCloneRequest();
    model.replace = false;
    model.data = "";
    //Recupero i caratteri in blackList dallo storage
    var blackListChars = sessionStorage.getItem('blackListChars');
    if (blackListChars == null || blackListChars == "")
      return model;

    const blackListArray = typeof blackListChars === 'string' ? JSON.parse(blackListChars) : blackListChars;

    for (let i = 0; i < blackListArray.length; i++) {
      const blackListChar = blackListArray[i];

      if (data.includes(blackListChar.CarattereBlackList)) {
        data = blackListChar.ReplaceWith ? data.replaceAll(blackListChar.CarattereBlackList, blackListChar.ReplaceWith) : data.replaceAll(blackListChar.CarattereBlackList, '');
        model.replace = true;
      }
    }

    model.data = data;
    return model;
  }
}
